import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ButtonColorEnum } from '../buttons/enums/button-color.enum';

@Component({
  selector: 'app-modal-response',
  templateUrl: './modal-response.component.html',
  styleUrls: ['./modal-response.component.scss']
})
export class ModalResponseComponent implements OnChanges {
  @Input() showModal: boolean = false;
  @Input() title: string = '';
  @Input() includeMain: boolean = true;
  @Input() icon: string = '';

  @Output() closeModalFunc: EventEmitter<boolean> = new EventEmitter<boolean>();

  public get ButtonColorEnum() { return ButtonColorEnum; }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['showModal']) {
      const newValue = changes['showModal'].currentValue;

      if (newValue) {
        document.body.classList.add('modal-open');
      } else {
        document.body.classList.remove('modal-open');
      }
    }
  }

  handleCloseModal() {
    document.body.classList.remove('modal-open');
    this.closeModalFunc.emit(false);
  }
}
